import { render, staticRenderFns } from "./webkamery.vue?vue&type=template&id=595b14ea&"
import script from "./webkamery.vue?vue&type=script&lang=js&"
export * from "./webkamery.vue?vue&type=script&lang=js&"
import style0 from "./webkamery.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports